import { __assign, __rest } from "tslib";
import React from 'react';
import Div100vh from 'react-div-100vh';
export default function FullHeight(_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return React.createElement(Div100vh, __assign({}, rest), children);
}
